export { default as DataTable } from './Table'
